(async () => {
  const root = document.getElementById('sdc-auto-localization');
  if (!root || window.Shopify?.designMode) return;
  const manualKey = 'sdc-localization-manual-v1';
  const checkedKey = 'sdc-localization-checked-v1';
  let manual = false;
  document.addEventListener('click', event => {
    if (!event.target.closest('localization-form a[data-value]')) return;
    manual = true;
    try { localStorage.setItem(manualKey, '1'); } catch {}
  }, true);
  try {
    if (localStorage.getItem(manualKey) || sessionStorage.getItem(checkedKey)) return;
    const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {signal: AbortSignal.timeout(5000)});
    if (!response.ok) return;
    const result = await response.json();
    const country = result.detected_values?.country?.handle;
    const locale = {IT: 'it', ES: 'es', GB: 'en'}[country];
    if (manual || !locale || !root.dataset.countries.split(/\s+/).includes(country) || !root.dataset.locales.split(/\s+/).includes(locale)) return;
    sessionStorage.setItem(checkedKey, '1');
    if (root.dataset.country === country && root.dataset.locale === locale) return;
    const form = root.querySelector('form');
    form.querySelector('[name="country_code"]').value = country;
    form.querySelector('[name="locale_code"]').value = locale;
    HTMLFormElement.prototype.submit.call(form);
  } catch {}
})();
